import React from "react";
import InputField from "../input/inputField";
import { DateField } from "../input/DateField";

interface Props {
  branchName: string;
  setBranchName: (branchName: string) => unknown;
  branchAddress: string;
  setBrachAddress: (branchAddress: string) => unknown;
  branchEstablished: string;
  setBranchEstablished: (branchEstablished: string) => unknown;
  branchDesc: string;
  setBranchDesc: (branchDesc: string) => unknown;
}

export const BranchForm = ({
  branchName,
  setBranchName,
  branchAddress,
  setBrachAddress,
  branchEstablished,
  setBranchEstablished,
  setBranchDesc,
  branchDesc,
}: Props) => {
  return (
    <div className="flex flex-col">
      <InputField
        value={branchName}
        setValue={setBranchName}
        label="Branch name"
        placeHolder="Enter branch name"
      />

      <InputField
        value={branchAddress}
        setValue={setBrachAddress}
        label="Branch addresss"
        placeHolder="Enter branch address"
      />

      <DateField
        date={branchEstablished}
        setDate={setBranchEstablished}
        label="Branch established date"
      />

      <InputField
        value={branchDesc}
        setValue={setBranchDesc}
        label="Branch description"
        placeHolder="Enter branch descriptions"
      />
    </div>
  );
};
